import {
  Hotel,
  Building2,
  Building,
  Home,
  ShoppingBag,
  Utensils,
  Warehouse,
  Plane,
  Ship,
  TreePine,
  Dumbbell,
  Hospital,
  GraduationCap,
  Store,
  Briefcase,
  type LucideIcon,
} from 'lucide-react';

// Icon mapping
export const ICON_MAP: Record<string, LucideIcon> = {
  Hotel: Hotel,
  Building2: Building2,
  Building: Building,
  Home: Home,
  ShoppingBag: ShoppingBag,
  Store: Store,
  Utensils: Utensils,
  Warehouse: Warehouse,
  Plane: Plane,
  Ship: Ship,
  TreePine: TreePine,
  Dumbbell: Dumbbell,
  Hospital: Hospital,
  GraduationCap: GraduationCap,
  Briefcase: Briefcase,
};

// Color mapping to Tailwind gradients
export const COLOR_MAP: Record<string, string> = {
  Blue: 'from-blue-500 to-blue-600',
  Green: 'from-green-500 to-green-600',
  Purple: 'from-purple-500 to-purple-600',
  Orange: 'from-orange-500 to-orange-600',
  Red: 'from-red-500 to-red-600',
  Pink: 'from-pink-500 to-pink-600',
  Indigo: 'from-indigo-500 to-indigo-600',
  Teal: 'from-teal-500 to-teal-600',
  Cyan: 'from-cyan-500 to-cyan-600',
  Amber: 'from-amber-500 to-amber-600',
};
